import i18next from 'i18next';
import generateHeaders from './myHeaders';

const getApiChatbotResponse = async (surveyId?: string, dashboardId?: string, indicatorId?: number, filter?: string, chatId?: string, chat?: string, selectedSchema?: string) => {
    const requestOptions = {
        method: 'GET',
        headers: generateHeaders(selectedSchema),
    };
    const requestFilter = filter ? `${filter}&chatId=${chatId}&chat=${chat}` : `?chatId=${chatId}&chat=${chat}`;

    return fetch(`${process.env.REACT_APP_API_URL}/survey/${surveyId}/dashboard/${dashboardId}/compute/${indicatorId}/CHATBOT${requestFilter}`, requestOptions)
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            return response.json();
        })
        .catch(() => ({ id: 0, entry: '', response: i18next.t('addIndicatorModal.addChatbotIndicator.chatbotUnavailable', { ns: 'dashboard' }) }));
};

export default getApiChatbotResponse;
